"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.TitlesDefaultCompact = void 0;
require("./TitlesDefaultCompact.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * TitlesDefault component
 *
 * @method
 * @param { TitlesDefaultCompactProps} props
 * @returns TitlesDefaultCompact
 */

const TitlesDefaultCompact = props => {
  const {
    countLabel,
    externalAction,
    headline,
    headlineTag = defaultProps.headlineTag,
    description,
    linkAction,
    subheadline,
    textAlignment,
    size
  } = props;
  if (!headline) {
    return null;
  }
  const hasAction = linkAction?.label || externalAction;
  const headlineStyle = textAlignment === 'center' ? 'title' : 'title-sm';
  const subHeadlineStyle = textAlignment === 'center' ? 'body-lg' : 'body';
  const componentClassName = (0, _classnames.default)('pal-c-TitlesDefaultCompact', {
    [`pal-c-TitlesDefaultCompact__alignment--${textAlignment}`]: textAlignment,
    [`pal-c-TitlesDefaultCompact__size--${size}`]: size
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, headline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefaultCompact__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefaultCompact__content--headline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: headlineStyle,
    htmlTag: headlineTag,
    textAlign: textAlignment,
    textColor: "content-default"
  }, headline), countLabel && /*#__PURE__*/_react.default.createElement(_Text.default, {
    className: "pal-c-TitlesDefaultCompact__content--countLabel",
    textStyle: subHeadlineStyle,
    htmlTag: "span",
    textAlign: textAlignment,
    textColor: "xsubtle"
  }, countLabel)), subheadline && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: subHeadlineStyle,
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: "body-default",
    className: "pal-c-TitlesDefaultCompact__content--subheadline"
  }, subheadline), description && /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: subHeadlineStyle,
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: "xsubtle",
    className: "pal-c-TitlesDefaultCompact__content--description"
  }, description)), hasAction && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefaultCompact__link"
  }, externalAction && (0, _renderObject.renderObject)(externalAction), !externalAction && /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    variant: "primary"
  }, linkAction))));
};

/**
 * Property type definitions
 * @typedef TitlesDefaultCompactProps
 * @type {object}
 * @property {string} countLabel - text for the count
 * @property {object} externalAction - external action object
 * @property {string} headline - headline text of the title
 * @property {string} headlineTag - headline tag of the title
 * @property {object} linkAction - action link for the title
 * @property {string} subheadline - subheadline tag of the title
 * @property {string} description - description of the title
 * @property {string} textAlignment - align the text (left or center)
 * @property {string} size - size of the overall component
 */
exports.TitlesDefaultCompact = TitlesDefaultCompact;
const propTypes = exports.propTypes = {
  countLabel: _propTypes.default.string,
  externalAction: _propTypes.default.object,
  headline: _propTypes.default.string,
  headlineTag: _propTypes.default.string,
  linkAction: _propTypes.default.object,
  subheadline: _propTypes.default.string,
  description: _propTypes.default.string,
  textAlignment: _propTypes.default.string,
  size: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} headlineTag='h2' - headline tag of the title
 */
const defaultProps = exports.defaultProps = {
  headlineTag: 'h2'
};
TitlesDefaultCompact.propTypes = propTypes;
var _default = exports.default = TitlesDefaultCompact;